/**
 * Search Selectors
 *
 * Memoized selectors for accessing destination search state.
 * Using createSelector ensures components only re-render when selected data changes.
 */
import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store/store';

// ============================================
// Base Selectors
// ============================================

const selectSearchState = (state: RootState) => state.onboarding.search;

// ============================================
// Search Selectors (Memoized)
// ============================================

export const selectDestinationSuggestions = createSelector(
  [selectSearchState],
  (search) => search.suggestions,
);

export const selectDestinationSearchLoading = createSelector(
  [selectSearchState],
  (search) => search.isLoading,
);

export const selectDestinationSearchError = createSelector(
  [selectSearchState],
  (search) => search.error,
);

export const selectLastSearchQuery = createSelector(
  [selectSearchState],
  (search) => search.lastQuery,
);
